import React, { useState, useEffect } from "react";
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '../icons/MenuIcon';
import IconBtn from "./IconBtn";
import clsx from "clsx";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from '@material-ui/core/Collapse';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Grid from "@material-ui/core/Grid";
import axios from 'axios';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../other/translate.json';
import config from '../other/config';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import utils from '../other/utils';
import CustomSelectBank from './CustomSelectBank'
import CustomAutocomplete from './CustomAutocomplete'
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ShareIcon from '../icons/ShareIcon';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import WriteToAs from "./WriteToUs";
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';

const { serverAPI } = config;
const { getStringFromStorage } = utils

const drawerWidth = 334;
function ListItemLink(props) {
	return <ListItem button={true} component="a" {...props} />;
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

export default function LeftBar(props) {

	const classes = useStyles();
	const [href, setHref] = useState(window.location.href)
	const { catalog, setCatalog } = props;
	const menuAppsRenderNew = props.menu//[menuAppsRenderNew, setMenuAppsRenderNew] = useState([]) /**Возможно стоит собрать всё меню в один запрос */
	const language = localStorage.getItem('language') || 'Ru'
	const LANG = language === 'Ru' ? 'Ru' : 'En';
	const { kloUser, _kloUser } = props
	const [stateAsk, setStateAsk] = React.useState(false);
	const [modalWriteToUs, _modalWriteToUs] = useState(false);

	// console.log("expanded", props.expanded)
	const getCatalogLink = () => {
		try {
			return window.location.href.split('/')[4]
		} catch {

		}

	}

	getCatalogLink()

	useEffect(() => {
		menuAppsRenderNew.map(elem => {
			if (getCatalogLink() === elem.URL) {
				if (elem.URL === 'cftbank' && ((window.location.href.indexOf('applications') > -1 && elem.ID_Category === 3) || (window.location.href.indexOf('products') > -1 && elem.ID_Category === 2)) || elem.URL !== 'cftbank') {
					setCatalog(elem);
					setHref(elem.isArchive === 1 ? 'archive' : getLink(elem.ID_Category))
					let needExpand = elem.isArchive === 1 ? 99 : elem.ID_Category;
					if (props.expanded !== needExpand) { props.handleExpandClick(needExpand) }
				}
			}
		})
	}, [menuAppsRenderNew]);

	function LinkToOLD() {
		if (window.location.pathname.slice(1, 13) === 'applications') {
			if (window.location.pathname.slice(14, 25) === 'bank-oracle') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 25)}`
				)
			}

			else if (window.location.pathname.slice(14, 23) === 'insurance') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 23)}`
				)
			}

			else if (window.location.pathname.slice(14, 25) === 'retail-bank') {
				return (
					`http://www.cft.ru/pages/${window.location.pathname.slice(14, 25)}`
				)
			}

			else if (window.location.pathname.slice(14, 16) === 'zk') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 16)}`
				)
			}

			else if (window.location.pathname.slice(14, 23) === 'corporate') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 23)}`
				)
			}

			else if (window.location.pathname.slice(14, 24) === 'management') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 24)}`
				)
			}

			else if (window.location.pathname.slice(14, 22) === 'platform') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 22)}`
				)
			}

			else if (window.location.pathname.slice(14, 17) === 'aml') {
				return (
					`https://www.cft.ru/pages/cft_aml`
				)
			}

			else if (window.location.pathname.slice(14, 20) === 'budget') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 20)}`
				)
			}

			else if (window.location.pathname.slice(14, 29) === 'digital-archive') {
				return (
					`http://www.cft.ru/pages/${window.location.pathname.slice(14, 29)}`
				)
			}

			else if (window.location.pathname.slice(14, 21) === 'machine') {
				return (
					`http://old-catalog.cft.ru/${window.location.pathname.slice(14, 21)}`
				)
			}

			else {
				return (
					`http://old-catalog.cft.ru/`
				)
			}
		} else {
			if (/products\/cftbank\/overview/gmi.test(window.location.pathname)) {
				return (
					`http://old-catalog.cft.ru/cftbank/Products/Default.aspx?type=13`
				)
			}
			else
				return (
					`http://old-catalog.cft.ru/`
				)
		}
	}

	const getLink = (ID_Category) => {
		switch (ID_Category) {
			case 1: { return 'solutions'; break; }
			case 2: { return 'products'; break; }
			case 3: { return 'applications'; break; }
			case 4: { return 'cloud'; break; }
			case 5: { return 'partners'; break; }
		}
	}

	function handleModalWriteToUs() {
		_modalWriteToUs(true)
		// setAddXLSX(false)
		setStateAsk(!stateAsk)
	}

	const renderCloud = () => {
		let cloudItems = 0;

		menuAppsRenderNew.map((item, count) => {
			if (item.ID_Category === 4 && item.isArchive === 0) {
				cloudItems++;
			}
		})

		if (menuAppsRenderNew && menuAppsRenderNew.length > 0 && cloudItems > 0) {
			return (
				<div>
					<ListItemLink key={`cloud${4}`} active={catalog.ID_Category === 4 && catalog.isArchive === 0}
						onClick={props.open === true ? () => { setHref('cloud'); props.handleExpandClick(4) } : () => props.setOpen(true)}
						className={classes.ListItemLink}
					>
						<ListItemIcon className={classes.listItem} key={'ListItemIcon_4'}>
							<IconBtn icon={4} size={'middle'} isActive={catalog.ID_Category === 4 && catalog.isArchive === 0} />
						</ListItemIcon>

						<ListItemText key={`ListItemText_`} primary={props.open === true ? translate.LetfMenu[`Cloud${LANG}`] : ''} className={classes.listItemText} />

						<IconButton
							className={clsx(classes.expand, {
								[classes.expandOpen]: props.expanded === 4,
							})}
							aria-expanded={props.expanded === 4}
							aria-label="show more"
						>
							<ArrowDropDownIcon className={classes.expandIcon} />
						</IconButton>
					</ListItemLink>

					<Collapse key={'Collapse_cloud'} in={props.open === true && props.expanded === 4} timeout="auto" unmountOnExit>
						<List component="nav">
							{menuAppsRenderNew.map((item, count) => {
								return (item.ID_Category === 4 && item.isArchive === 0 ?
									<div className={classes.a0} key={`${count}menuAppsRender4`}>
										<ListItemLink
											button
											id={item.URL}
											href={`/cloud/${item.URL}/overview`}
											key={`menuAppsRender4${count}`}
											className={classes.a1}
											selected={window.location.href.includes('cloud') && window.location.href.includes(`/${item.URL}/`)}
											onClick={() => {
												// props.setListNumProps(0)
												props.handleListItemClick(40 + count, item)
												props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
											}}
										>
											<ListItemText key={`ListItemText_4${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
											<ListItemText key={`ListItemText_primary4${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
										</ListItemLink>
									</div>
									:
									null
								)
							})}
						</List>
					</Collapse>
				</div>
			)
		}
	}

	return (
		<Drawer
			id={props.open ? 'drawerOpenScroll' : ''}
			open={props.open || props.matches.large}
			variant={window.innerWidth > 1365 ? "permanent" : "temporary"}
			onClose={() => props.handleDrawer()}
			classes={{
				paper: clsx({
					[classes.drawerOpen]: props.open,
					[classes.drawerClose]: !props.open
				})
			}}
		>
			<div className={classes.toolbar}>
				<IconButton
					color="inherit"
					aria-label="open drawer"
					onClick={() => props.handleDrawer()}
					// onBlur={() => handleDrawer(false)}
					edge="start"
					className={clsx(classes.menuButton, {
						// [classes.hide]: open
					})}
				>
					<MenuIcon fill={'#FFFFFF'} />
				</IconButton>

				<Typography onClick={() => props.handleDrawer()} style={{ fontSize: '18px', fontWeight: 500, display: props.open === true ? '' : 'none', cursor: 'default' }}>{translate.LetfMenu[`Menu${LANG}`]}</Typography>

			</div>

			{/* {
				props.open && kloUser.user && kloUser.user.IS_BANK && showBankSelect
				?
				<Grid container  className={classes.bankSelectContainer}>
					<FormControl className={classes.bankSelect}>
						<InputLabel id="splabel">Банк</InputLabel>
						<Select
						inputProps={{color:'#fff'}}
						label ='Банк'
							value = {kloUser.currentBank.name}
						> 
							{
								kloUser.banks.map((bank,i) =>{
									return (
										<MenuItem  key = {i}   value={ bank.name  }>{ bank.name}</MenuItem>
									)
								})
							}
							 

						</Select>
					</FormControl>
				</Grid>
				:
				null} */}



			{/* <Divider /> */}
			<Grid
				container
				direction="column"
				justifyContent="space-between"
				alignItems="flex-start"
				style={{
					justifyContent: 'space-between', height: '100%', flexWrap: 'nowrap',
				}}
			>
				<Grid item>
					<List key={'leftbar_gener'}>
						{/* <Link id='a123' to={`/`}> */}
						<div> {/** Главная */}
							<ListItemLink
								// button 
								key={'ListItemLink'}
								href={`/`}
								active={window.location.href.split('/').length <= 4 || false}
								// key={0}
								onClick={
									props.open === true ? () => props.handleExpandClick(0) : () => props.setOpen(true)} // TODO: ALEXEY - Надо пофиксить. Не сворачивает при нажатии
							>
								<ListItemIcon className={classes.listItem} key={'ListItemIcon_0'}>
									<IconBtn
										icon={0}
										size={'middle'}
									// key={selectedIndex}
									// active={props.expanded === 0}
									/>
								</ListItemIcon>
								<ListItemText key={`ListItemText_leftbar_gener`} primary={props.open === true ? translate.LetfMenu[`Home${LANG}`] : ''} className={classes.listItemHeader} />
							</ListItemLink>
						</div> {/* Главная **/}
						{/* </Link> */}

						{menuAppsRenderNew && menuAppsRenderNew.length > 0 ?
							(<div> {/** Готовые решения */}
								<ListItemLink
									key='ListItemLink1'
									active={/*/solutions/gmi.test(window.location.href)*/catalog.ID_Category === 1 && catalog.isArchive === 0}
									onClick={
										props.open === true ? () => { setHref('solutions'); props.handleExpandClick(1) } : () => props.setOpen(true)
									}
									className={classes.ListItemLink}
								>
									<ListItemIcon className={classes.listItem} key={'ListItemIcon_1'}>
										<IconBtn icon={1} size={'middle'} /* active={props.expanded === 1} */ isActive={catalog.ID_Category === 1 && catalog.isArchive === 0} />
									</ListItemIcon>

									<ListItemText key={`ListItemText_1`} primary={props.open === true ? translate.LetfMenu[`Solution${LANG}`] : ''} className={classes.listItemText} />

									<IconButton
										className={clsx(classes.expand, {
											[classes.expandOpen]: props.expanded === 1,
										})}
										aria-expanded={props.expanded === 1}
										aria-label="show more"
									>
										<ArrowDropDownIcon className={classes.expandIcon} />
									</IconButton>
								</ListItemLink>

								<Collapse key={'Collapse_solutions'} in={props.open === true /*&& /solutions/gmi.test(href)*/ && props.expanded === 1} timeout="auto" unmountOnExit>
									<List component="nav">
										{menuAppsRenderNew.map((item, count) =>
											item.ID_Category === 1 && item.isArchive === 0 ?
												<div className={classes.a0} key={`${count}menuAppsRender1`}>
													<ListItemLink
														button
														id={item.URL}
														href={`/solutions/${item.URL}/overview`}
														key={`menuAppsRender1${item.HashCode}`}
														className={classes.a1}
														selected={window.location.href.includes('solutions') && window.location.href.includes(`/${item.URL}/`)}
														onClick={() => {
															// props.setListNumProps(0)
															props.handleListItemClick(10 + count, item)
															props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
														}}
													>
														<ListItemText key={`ListItemText_1${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
														<ListItemText key={`ListItemText_primary1${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
													</ListItemLink>
												</div>
												: null
										)}
									</List>
								</Collapse>
							</div>) : null
						} {/* Готовые решения **/}

						{menuAppsRenderNew && menuAppsRenderNew.length > 0 ?
							<div>
								<ListItemLink key='ListItemLink2' active={/*/products/gmi.test(window.location.href)*/catalog.ID_Category === 2 && catalog.isArchive === 0}
									onClick={props.open === true ? () => { setHref('products'); props.handleExpandClick(2) } : () => props.setOpen(true)}
									className={classes.ListItemLink}
								>
									<ListItemIcon className={classes.listItem} key={`ListItemIcon_2`}>
										<IconBtn icon={2} size={'middle'} isActive={catalog.ID_Category === 2 && catalog.isArchive === 0} />
									</ListItemIcon>

									<ListItemText key={`ListItemText_2`} primary={props.open === true ? translate.LetfMenu[`Catalog${LANG}`] : ''} className={classes.listItemText} />

									<IconButton
										className={clsx(classes.expand, {
											[classes.expandOpen]: props.expanded === 2,
										})}
										aria-expanded={props.expanded === 2}
										aria-label="show more"
									>
										<ArrowDropDownIcon className={classes.expandIcon} />
									</IconButton>
								</ListItemLink>

								<Collapse key={'Collapse_products'} in={props.open === true && props.expanded === 2} timeout="auto" unmountOnExit>
									<List component="nav">
										{menuAppsRenderNew.map((item, count) =>
											item.ID_Category === 2 && item.isArchive === 0 ?
												<div className={classes.a0} key={`${count}menuAppsRender2${item.HashCode}`}>
													<ListItemLink
														button
														id={item.URL}
														href={`/products/${item.URL}/overview`}
														key={`menuAppsRender2${item.HashCode}`}
														className={classes.a1}
														selected={window.location.href.includes('products') && window.location.href.includes(`/${item.URL}/`)}
														onClick={() => {
															// props.setListNumProps(0)
															props.handleListItemClick(20 + count, item)
															props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
														}}
													>
														<ListItemText key={`ListItemText_${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
														<ListItemText key={`ListItemText_primary2${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
													</ListItemLink>
												</div>
												:
												null
										)}
									</List>
								</Collapse>
							</div>
							:
							null
						} {/* =============== ПРОДУКТЫ ===== */}

						{/* ===== ПРИЛОЖЕНИЯ =============== */}
						{menuAppsRenderNew && menuAppsRenderNew.length > 0 ?
							(<div>
								<ListItemLink
									key='ListItemLink3'
									active={/*/applications/gmi.test(window.location.href)*/catalog.ID_Category === 3 && catalog.isArchive === 0}
									onClick={props.open === true ? () => { setHref('applications'); props.handleExpandClick(3) } : () => props.setOpen(true)}
									className={classes.ListItemLink}
								>
									<ListItemIcon className={classes.listItem} key={`ListItemIcon_3`}>
										<IconBtn icon={3} size={'middle'} isActive={catalog.ID_Category === 3 && catalog.isArchive === 0} />
									</ListItemIcon>

									<ListItemText key={`ListItemText_3`} primary={props.open === true ? translate.LetfMenu[`Directories${LANG}`] : ''} className={classes.listItemText} />

									<IconButton
										className={clsx(classes.expand, {
											[classes.expandOpen]: props.expanded === 3,
										})}
										aria-expanded={props.expanded === 3}
										aria-label="show more"
									>
										<ArrowDropDownIcon className={classes.expandIcon} />
									</IconButton>
								</ListItemLink>

								<Collapse key={'Collapse_applications'} in={props.open === true && props.expanded === 3} timeout="auto" unmountOnExit >
									<List component="nav" >
										{menuAppsRenderNew.map((item, count) =>
											item.ID_Category === 3 && item.isArchive === 0 ?
												<div className={classes.a0} key={`classes.a0${item.HashCode}${count}`}>
													<ListItemLink
														button
														id={item.URL}
														href={`/applications/${item.URL}/overview`}
														key={`menuAppsRender3${item.HashCode}${count}`}
														className={classes.a1}
														selected={window.location.href.includes('applications') && window.location.href.includes(`/${item.URL}/`)}
														onClick={() => {
															// props.setListNumProps(0)
															props.handleListItemClick(30 + count, item, item.URL)
															props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
														}}
													>
														<ListItemText key={`ListItemText_3${item.HashCode}${item.count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
														<ListItemText key={`ListItemText_primary3${item.HashCode}${item.count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
													</ListItemLink>
												</div> : null
										)}
									</List>
								</Collapse>
							</div>) : ''}

						{menuAppsRenderNew && menuAppsRenderNew.filter(elem => elem.ID_Category === 4).length > 0
							?
							(
								<div>
									<ListItemLink key={`cloud${4}`} active={catalog.ID_Category === 4 && catalog.isArchive === 0}
										onClick={props.open === true ? () => { setHref('cloud'); props.handleExpandClick(4) } : () => props.setOpen(true)}
										className={classes.ListItemLink}
									>
										<ListItemIcon className={classes.listItem} key={'ListItemIcon_4'}>
											<IconBtn icon={4} size={'middle'} isActive={catalog.ID_Category === 4 && catalog.isArchive === 0} />
										</ListItemIcon>

										<ListItemText key={`ListItemText_`} primary={props.open === true ? translate.LetfMenu[`Cloud${LANG}`] : ''} className={classes.listItemText} />

										<IconButton
											className={clsx(classes.expand, {
												[classes.expandOpen]: props.expanded === 4,
											})}
											aria-expanded={props.expanded === 4}
											aria-label="show more"
										>
											<ArrowDropDownIcon className={classes.expandIcon} />
										</IconButton>
									</ListItemLink>

									<Collapse key={'Collapse_cloud'} in={props.open === true && props.expanded === 4} timeout="auto" unmountOnExit>
										<List component="nav">
											{menuAppsRenderNew.map((item, count) => {
												return (item.ID_Category === 4 && item.isArchive === 0 ?
													<div className={classes.a0} key={`${count}menuAppsRender4`}>
														<ListItemLink
															button
															id={item.URL}
															href={`/cloud/${item.URL}/overview`}
															key={`menuAppsRender4${count}`}
															className={classes.a1}
															selected={window.location.href.includes('cloud') && window.location.href.includes(`/${item.URL}/`)}
															onClick={() => {
																// props.setListNumProps(0)
																props.handleListItemClick(40 + count, item)
																props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
															}}
														>
															<ListItemText key={`ListItemText_4${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
															<ListItemText key={`ListItemText_primary4${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
														</ListItemLink>
													</div>
													: ''
												)
											}
											)}
										</List>
									</Collapse>
								</div>
							)
							:
							''
						}{/* =============== ПРИЛОЖЕНИЯ ===== */}

						{renderCloud()}

						{menuAppsRenderNew && menuAppsRenderNew.length > 0 && menuAppsRenderNew.filter(elem => elem.ID_Category === 5).length > 0
							?
							(
								<div>
									<ListItemLink key={`partners${5}`} active={catalog.ID_Category === 5 && catalog.isArchive === 0}
										onClick={props.open === true ? () => { setHref('partners'); props.handleExpandClick(5) } : () => props.setOpen(true)}
										className={classes.ListItemLink}
									>
										<ListItemIcon className={classes.listItem} key={'ListItemIcon_5'}>
											<IconBtn icon={11} size={'middle'} isActive={catalog.ID_Category === 5 && catalog.isArchive === 0} />
										</ListItemIcon>

										<ListItemText key={`ListItemText_`} primary={props.open === true ? translate.LetfMenu[`Partners${LANG}`] : ''} className={classes.listItemText} />

										<IconButton
											className={clsx(classes.expand, {
												[classes.expandOpen]: props.expanded === 5,
											})}
											aria-expanded={props.expanded === 5}
											aria-label="show more"
										>
											<ArrowDropDownIcon className={classes.expandIcon} />
										</IconButton>
									</ListItemLink>

									<Collapse key={'Collapse_cloud'} in={props.open === true && props.expanded === 5} timeout="auto" unmountOnExit>
										<List component="nav">
											{menuAppsRenderNew.map((item, count) => {
												return (item.ID_Category === 5 && item.isArchive === 0 ?
													<div className={classes.a0} key={`${count}menuAppsRender4`}>
														<ListItemLink
															button
															id={item.URL}
															href={`/partners/${item.URL}/overview`}
															key={`menuAppsRender5${count}`}
															className={classes.a1}
															selected={window.location.href.includes('partners') && window.location.href.includes(`/${item.URL}/`)}
															onClick={() => {
																// props.setListNumProps(0)
																props.handleListItemClick(40 + count, item)
																props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
															}}
														>
															<ListItemText key={`ListItemText_5${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
															<ListItemText key={`ListItemText_primary5${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
														</ListItemLink>
													</div>
													: ''
												)
											}
											)}
										</List>
									</Collapse>
								</div>
							)
							:
							null
						}
						{menuAppsRenderNew && menuAppsRenderNew.length > 0 && menuAppsRenderNew.filter(elem => elem.isArchive === 1).length > 0 && false // CTG-483
							?
							(
								<div>
									<ListItemLink key={`cloud${99}`} active={catalog.isArchive === 1}
										onClick={props.open === true ? () => { setHref('cloud'); props.handleExpandClick(99) } : () => props.setOpen(true)}
										className={classes.ListItemLink}
									>
										{<ListItemIcon className={classes.listItem} key={'ListItemIcon_99'}>
											<IconBtn icon={10} size={'middle'} isActive={catalog.isArchive === 1} />
										</ListItemIcon>}

										<ListItemText key={`ListItemText_`} primary={props.open === true ? translate.LetfMenu[`Archive${LANG}`] : ''} className={classes.listItemText} />

										<IconButton
											className={clsx(classes.expand, {
												[classes.expandOpen]: props.expanded === 99,
											})}
											aria-expanded={props.expanded === 99}
											aria-label="show more"
										>
											<ArrowDropDownIcon className={classes.expandIcon} />
										</IconButton>
									</ListItemLink>

									<Collapse key={'Collapse_cloud'} in={props.open === true /*&& catalog.isArchive ===1*/ && props.expanded === 99} timeout="auto" unmountOnExit>
										<List component="nav">
											{menuAppsRenderNew.map((item, count) => {
												return (item.isArchive === 1 ?
													<div className={classes.a0} key={`${count}menuAppsRender99`}>
														<ListItemLink
															button
															id={item.URL}
															href={`/${getLink(item.ID_Category)}/${item.URL}/overview`}
															key={`menuAppsRender4${count}`}
															className={classes.a1}
															selected={window.location.href.includes(`/${item.URL}/`)}
															onClick={() => {
																// props.setListNumProps(0)
																props.handleListItemClick(40 + count, item)
																props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
															}}
														>
															<ListItemText key={`ListItemText_4${count}`} primary={props.open === true ? item[`Title`] : ''} className={classes.listItemCollapseText} />
															<ListItemText key={`ListItemText_primary4${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} />
														</ListItemLink>
													</div>
													: ''
												)
											}
											)}
										</List>
									</Collapse>
								</div>
							)
							:
							null
						}
					</List>
				</Grid>

				<Grid item style={{ width: '100%' }}>
					{
						props.open === true
							?
							<List key={'leftbar_sec'} style={{ padding: 0 }}>
								<div className={classes.a01}>
									<ListItemLink
										button
										id={'about'}
										href={`/about`}
										className={classes.a11}
										selected={window.location.href.includes('about')}
										onClick={() => {
											// props.setListNumProps(0)
											//props.handleListItemClick(40 + count, item)
											props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
										}}
									>
										<ListItemIcon style={{ marginLeft: 6 }}>
											<InfoOutlinedIcon htmlColor='#BCBBD0' />
										</ListItemIcon>
										<ListItemText primary={language === 'Ru' ? 'О компании' : 'About us'} className={classes.listItemCollapseText} />
										{/* <ListItemText key={`ListItemText_primary5${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} /> */}
									</ListItemLink>
								</div>

								<div className={classes.a01}>
									<ListItemLink
										button
										id={'contacts'}
										href={`/contacts`}
										className={classes.a11}
										selected={window.location.href.includes('contacts')}
										onClick={() => {
											// props.setListNumProps(0)
											//props.handleListItemClick(40 + count, item)
											props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
										}}
									>
										<ListItemIcon style={{ marginLeft: 6 }}>
											<ShareIcon fill='#BCBBD0' />
										</ListItemIcon>
										<ListItemText primary={language === 'Ru' ? 'Контакты' : 'Contacts'} className={classes.listItemCollapseText} />
										{/* <ListItemText key={`ListItemText_primary5${count}`} primary={props.open === true ? item.count > 0 ? item.count : '' : ''} className={classes.listItemCollapseCount} /> */}
									</ListItemLink>
								</div>

								<HtmlTooltip
									interactive
									placement="right"
									title={
										!props.isAuth
											?
											language === 'Ru'
												?
												<Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
												:
												<Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
											:
											<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`RequestACallback${language}`]}</Grid>
									}
								>
									<div className={classes.a01}>

										<ListItemLink
											button
											id={'writetous'}
											className={classes.a11}
											onClick={() => props.isAuth ? handleModalWriteToUs() : null}
										>
											<ListItemIcon style={{ marginLeft: 6 }}>
												<EmailOutlinedIcon htmlColor='#BCBBD0' />
											</ListItemIcon>
											<ListItemText primary={language === 'Ru' ? 'Написать нам' : 'Write to us'} className={classes.listItemCollapseText} />
										</ListItemLink>
									</div>
								</HtmlTooltip>
							</List>
							:
							<React.Fragment>
								<Tooltip title={language === 'Ru' ? 'О компании' : 'About us'}>
									<div>
										<IconButton
											component="a"
											id={'about-short'}
											href={`/about`}
											className={classes.a11}
											style={{
												borderRadius: 0,
												border: 'none',
												backgroundColor: window.location.href.includes('about') ? 'rgba(0, 0, 0, 0.08)' : null,
												width: '100%',
												height: 58,
											}}
											onClick={() => {
												props.setOpen(document.documentElement.clientWidth < 1366 ? false : props.open)
											}}
										>
											<InfoOutlinedIcon htmlColor='#BCBBD0' />
										</IconButton>
									</div>
								</Tooltip>

								<Tooltip title={language === 'Ru' ? 'Контакты' : 'Contacts'}>
									<div>
										<IconButton
											component="a"
											id={'contacts-short'}
											href={`/contacts`}
											className={classes.a11}
											style={{
												borderRadius: 0,
												backgroundColor: window.location.href.includes('contacts') ? 'rgba(0, 0, 0, 0.08)' : null,
												width: '100%',
												height: 58,
											}}
										>
											<ShareIcon fill='#BCBBD0' />
										</IconButton >
									</div>
								</Tooltip>

								<HtmlTooltip
									interactive
									placement="right"
									title={
										!props.isAuth
											?
											language === 'Ru'
												?
												<Grid item style={{ fontSize: '14px !important' }}><a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Авторизуйтесь</a>, чтобы отправить сообщение</Grid>
												:
												<Grid item style={{ fontSize: '14px !important' }}>Please <a href={'https://catalog.cft.ru/login?linkTo=' + window.location.href}>Log in</a> to send message</Grid>
											:
											<Grid item style={{ fontSize: '14px !important' }}>{translate.Words[`WriteToUs_${language}`]}</Grid>
									}
								>
									<div>
										<IconButton
											id={'writetous-short'}
											className={classes.a11}
											component="button"
											onClick={() => props.isAuth ? handleModalWriteToUs() : null}
											style={{
												borderRadius: 0,
												width: '100%',
												height: 58,
											}}
										>
											<EmailOutlinedIcon htmlColor='#BCBBD0' />
										</IconButton>
									</div>
								</HtmlTooltip>
							</React.Fragment>
					}
				</Grid>
			</Grid>

			<Grid item container direction="row" justify="flex-start" alignItems="center">
				<Grid item style={{ marginRight: 16 }} >
					<WriteToAs
						usname={props.usname}
						setUsname={props.setUsname}
						isAuth={props.isAuth}
						setIsAuth={props.setIsAuth}
						stateAsk={stateAsk}
						setStateAsk={setStateAsk}
						AskCFT={modalWriteToUs}
					// AddXLSX={addXLSX}
					// submit={'ask'}
					// link={`${serverAPI}/solutions_v4/${ID}?lang=${lang}`}
					/>
				</Grid>
			</Grid>
		</Drawer>
	);
}

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.87)',
		color: 'rgba(255, 255, 255, 0.87)',
		maxWidth: 500,
		fontSize: theme.typography.pxToRem(12),
		borderRadius: '8px',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 400,
		padding: 12,
		opacity: 0.5,

		'& a': {
			color: 'rgba(255, 255, 255, 0.87)',
		}
	},
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
	a0: {
		padding: '0 24px 0 24px'
	},

	a01: {
		padding: 0,
		borderTop: '1px solid #3C3C56',
	},

	a1: {
		borderRadius: 16,
		padding: '5px 16px 4px 18px',
	},

	a11: {
		borderRadius: 0,
		padding: '5px 16px 4px 18px',
		backgroundColor: '#33334D'
	},

	menuButton: {
		marginTop: 24,
		marginRight: 9,
		marginBottom: 24,
		marginLeft: 5
	},
	menuBankButton: {
		marginLeft: '50%'
	},

	hide: {
		display: "none"
	},
	bankSelect: {
		padding: '8px 16px',
		width: '100%'
	},

	bankSelectContainer: {
		padding: '8px 16px',

	},

	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
	},

	drawerOpen: {
		width: drawerWidth,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		backgroundColor: '#3C3C56',
		color: '#FFF',
		overflow: 'overlay'
	},

	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),

		overflowX: "hidden",
		width: theme.spacing(0),
		[theme.breakpoints.up(1365)]: {
			width: 96,
		},

		backgroundColor: '#3C3C56',
		color: '#FFF'
	},

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		marginBottom: 17,
		minHeight: '96px !important',
		// necessary for content to be below app bar
		// ...theme.mixins.toolbar
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemBackToOld: {
		width: 62,
		padding: 0,
		overflow: 'hidden'
	},

	a1BackToOld: {
		borderRadius: 16,
		padding: 0,
	},

	listItemHeader: {
		padding: theme.spacing(1, 1),
		fontWeight: 500
	},

	listItemText: {
		padding: '8px 0 8px 8px',
	},

	listItemCollapseText: {
		padding: theme.spacing(1, 0)
	},

	listItemCollapseCount: {
		padding: theme.spacing(1, 0),
		textAlign: 'right',
		marginLeft: theme.spacing(0.5)
	},

	paper: {
		padding: theme.spacing(3),
		minHeight: 100,
		textAlign: "center",
		color: theme.palette.text.secondary
	},


	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
	},

	expandOpen: {
		transform: 'rotate(180deg)',
	},

	expandIcon: {
		color: '#FFFFFF'
	},

	ListItemLink: {
		paddingRight: 8
	}
}));